import { render, staticRenderFns } from "./ProjectPortfolio.vue?vue&type=template&id=635edbb2&scoped=true"
import script from "./ProjectPortfolio.vue?vue&type=script&lang=js"
export * from "./ProjectPortfolio.vue?vue&type=script&lang=js"
import style0 from "./ProjectPortfolio.vue?vue&type=style&index=0&id=635edbb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635edbb2",
  null
  
)

export default component.exports